export var PurchaseSource;
(function (PurchaseSource) {
    PurchaseSource["EDI"] = "edi";
    PurchaseSource["CSV"] = "csv_import";
})(PurchaseSource || (PurchaseSource = {}));
